import { render } from "./breadCrumb.vue?vue&type=template&id=701b873a"
import script from "./breadCrumb.vue?vue&type=script&lang=js"
export * from "./breadCrumb.vue?vue&type=script&lang=js"

import "./breadCrumb.vue?vue&type=style&index=0&id=701b873a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/breadCrumb.vue'],['render',render],['__file',"breadCrumb.vue"]])

export default __exports__